import React, { useState, useEffect, useRef } from "react"
import scrollTo from "gatsby-plugin-smoothscroll"

const DARK_SECTION_IDS = ["books", "podcast", "contact"]

export default function ScrollUpButton() {
  const [visible, setVisible] = useState(false)
  const [onDark, setOnDark] = useState(false)
  const btnRef = useRef(null)

  useEffect(() => {
    function update() {
      setVisible(window.scrollY > 300)

      const node = btnRef.current
      if (!node) return
      const rect = node.getBoundingClientRect()
      const probeY = rect.top + rect.height / 2

      let dark = false
      for (const id of DARK_SECTION_IDS) {
        const el = document.getElementById(id)
        if (!el) continue
        const r = el.getBoundingClientRect()
        if (r.top <= probeY && r.bottom >= probeY) {
          dark = true
          break
        }
      }
      setOnDark(dark)
    }
    window.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update)
    update()
    return () => {
      window.removeEventListener("scroll", update)
      window.removeEventListener("resize", update)
    }
  }, [])

  function handleClick() {
    scrollTo("#top")
  }

  const palette = onDark
    ? { bg: "white", color: "var(--cobalt)", shadow: "0 6px 18px rgba(0,0,0,0.45)" }
    : { bg: "var(--cobalt)", color: "white", shadow: "0 6px 18px rgba(28,54,116,0.35)" }

  return (
    <button
      ref={btnRef}
      type="button"
      aria-label="Back to top"
      onClick={handleClick}
      style={{
        ...btnStyle,
        background: palette.bg,
        color: palette.color,
        boxShadow: palette.shadow,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(8px)",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  )
}

const btnStyle = {
  position: "fixed",
  right: "24px",
  bottom: "24px",
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.25s ease, transform 0.25s ease, background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease",
  zIndex: 9999,
}
